<template>
    <picture
        v-if="hasImage"
        :class="className"
    >
        <source
            v-if="srcset"
            :srcset="srcset"
        />
        <img
            :src="image.url"
            :alt="image.alt"
            :width="image.dimensions.width"
            :height="image.dimensions.height"
            loading="lazy"
            class="o-asset__img"
            @load="setLoadedState"
        />
    </picture>
</template>

<script>

export default {
    name: 'Asset',
    props: {
        image: {
            type: Object,
            default: null
        },
        cover: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: null
        },
    },
    data: () => ({
        isLoaded: false
    }),
    computed: {
        className() {
            let classname = 'o-asset'

            if(this.cover) {
                classname += ' -cover'
            }

            if(this.isLoaded) {
                classname += ' -loaded'
            }

            return classname
        },
        hasImage() {
            return !!(this.image && this.image.url)
        },

        srcset() {
            if(!this.hasImage) {
                return false
            }

            let srcset = ''

            if(this.size) {
                const baseurl = `${this.image.url}?fit=crop&q=80&${this.size}`
                srcset = `${baseurl}&dpr=1 1x, ${baseurl}&dpr=2 2x, ${baseurl}&dpr=3 3x,`
            } else {
                srcset = this.image.url
            }

            return srcset
        },
        // styles() {
        //     let styles = `--ratio: ${this.ratio};`

        //     return styles
        // },
        // ratio() {
        //     return (this.width/this.height).toFixed(3)
        // },
        // width() {
        //     if(!this.hasImage) {
        //         return 0
        //     }

        //     return this.image.dimensions ? this.image.dimensions.width : this.image.width
        // },
        // height() {
        //     if(!this.hasImage) {
        //         return 0
        //     }

        //     return this.image.dimensions ? this.image.dimensions.height : this.image.height
        // },
    },
    methods: {
        setLoadedState() {
            this.isLoaded = true
            this.$emit('load')
        }
    }
};

</script>

<style lang="scss">

.o-asset {
    display: block;
    background: $color-light;
    &.-cover {

        .o-asset__img {
            object-fit: cover;
            object-position: 50% 50%;
        }
    }

    &.-loaded {
        .o-asset__img {
            opacity: 1;
        }
    }

    .o-asset__img {
        opacity: 0;
        transition: opacity 0.5s ease-out;
    }


}

.o-asset__img {
    @include img;
}

</style>
